/**
 * SpeedmasterWarranty.Cart.js
 * Cart mounting module — injects the warranty summary/manager view
 * inside the Order Summary card (before the loyalty/points section).
 *
 * The summary view handles:
 *   1. Per-line warranty toggles (rendered within cart lines via DOM)
 *   2. Warranty summary breakdown with total
 *   3. Warranty service line item styling (compact row at bottom of items list)
 */
define('SpeedmasterWarranty.Cart', [
    'SpeedmasterWarranty.Cart.Summary',
    'SpeedmasterWarranty.Config',
    'jQuery'
], function SpeedmasterWarrantyCartDef(
    CartSummary,
    WarrantyConfig,
    jQuery
) {
    'use strict';

    return {

        /**
         * @param {Object} container  SCS application container
         */
        mountToApp: function mountToApp(container) {
            var cart = container.getComponent('Cart');
            if (!cart) { return; }

            var cfg = WarrantyConfig.get();

            // Injected inside Order Summary card, just before the points/loyalty section
            var childViewObject = {
                'cms:cart_warranty_summary': {
                    'SpeedmasterWarrantySummary': {
                        childViewConstructor: function childViewConstructor() {
                            return new CartSummary({ cart: cart });
                        }
                    }
                }
            };

            cart.addChildViews(cart.CART_VIEW, childViewObject);

            // Redirect warranty line clicks to /extended-warranty instead of item page
            jQuery(document).on(
                'click.speedmasterWarrantyLine',
                '[data-item-id="' + cfg.warrantyItemId + '"] .cart-lines-name-link',
                function (e) {
                    e.preventDefault();
                    window.location.hash = '/extended-warranty';
                }
            );
        }
    };
});
